<div class="container-fluid psp-container">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'../'"
    [currentPageValue]="'Request Medical Test'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="add-test-container">
      <div class="card-body">
        <div class="card-title">
          <h2>Request Medical Test</h2>
          <div class="divider"></div>
          <!-- Test button for toast notification -->
          <button
            type="button"
            class="btn btn-sm btn-success"
            (click)="testToastNotification()"
            style="margin-top: 10px;"
          >
            Test Toast Notification
          </button>
        </div>

        <ul class="steps">
          <li
            class="step location-step"
            (click)="onStepClick(1)"
            [ngClass]="{ active: step == 1 }"
          >
            <div class="step-icon">
              <div class="icon-wrapper">
                <img src="../../../../assets/location.png" alt="Step One" />
              </div>
            </div>
            <p class="step-number">Step 01</p>
            <p class="step-text">Select Test and location</p>
          </li>
          <li
            class="step lab-step"
            (click)="onStepClick(2)"
            [ngClass]="{ active: step == 2 }"
          >
            <div class="step-icon">
              <div class="icon-wrapper">
                <img src="../../../../assets/lab.png" alt="Step Two" />
              </div>
            </div>
            <p class="step-number">Step 02</p>
            <p class="step-text">Available Labs</p>
          </li>
          <li
            class="step payment-step"
            (click)="onStepClick(3)"
            [ngClass]="{ active: step == 3 }"
          >
            <div class="step-icon">
              <div class="icon-wrapper">
                <img src="../../../../assets/payment.png" alt="Step Three" />
              </div>
            </div>
            <p class="step-number">Step 03</p>
            <p class="step-text">Payment Information</p>
          </li>
          <li
            class="step confirm-step"
            (click)="onStepClick(4)"
            [ngClass]="{ active: step == 4 }"
          >
            <div class="step-icon">
              <div class="icon-wrapper">
                <img src="../../../../assets/confirm.png" alt="Step Four" />
              </div>
            </div>
            <p class="step-number">Step 04</p>
            <p class="step-text">Request Confirmation</p>
          </li>
        </ul>

        <form *ngIf="step == 1" [formGroup]="testAndLocationForm">
          <div class="row justify-content-between">
            <div class="col-md-8">
              <h2 class="form-section-title">Requested Test(s)</h2>
            </div>
            <div class="col-md-4">
                <select
                  class="form-control"
                  id="testTypeId"
                  (change)="handleSelectedTestType()"
                  formControlName="testTypeId"
                >
                  <option [ngValue]="null" [disabled]="true" >Select Test Type</option>
                  <option *ngFor="let testType of availableTestTypes" [ngValue]="testType.id">
                    {{ testType.type }}
                  </option>
                </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" *ngIf="selectedTestTypeId == testTypes.Lab || selectedTestTypeId == testTypes.Default">
              <div class="form-group" formGroupName="medicalTestsDetails">
                <label class="form-control-label" for="medical-tests">
                  Medical Test(s)
                </label>
                <ng-multiselect-dropdown
                  id="medical-tests"
                  formControlName="medicalTests"
                  [placeholder]="'Select'"
                  [settings]="{
                    singleSelection: false,
                    enableCheckAll: false,
                    searchPlaceholderText: 'Search Test',
                    itemsShowLimit: 3,
                    idField: 'id',
                    textField: 'name',
                    allowSearchFilter: true,
                    closeDropDownOnSelection: false
                  }"
                  [data]="labTests"
                >
                </ng-multiselect-dropdown>
                <div
                  *ngIf="
                    testAndLocationForm.controls.medicalTestsDetails.controls.medicalTests.dirty &&
                    testAndLocationForm.controls.medicalTestsDetails.controls.medicalTests.errors
                  "
                  class="input-errors"
                >
                  <p
                    *ngIf="
                      testAndLocationForm.controls.medicalTestsDetails.controls.medicalTests.errors.required
                    "
                  >
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="selectedTestTypeId == testTypes.Scan || selectedTestTypeId == testTypes.Default">
              <div class="form-group" formGroupName="radiologyTestsDetails">
                <label class="form-control-label" for="radiology-tests">
                  Radiology Test(s)
                </label>
                <ng-multiselect-dropdown
                  id="radiology-tests"
                  formControlName="radiologyTests"
                  [placeholder]="'Select'"
                  [settings]="{
                    singleSelection: false,
                    enableCheckAll: false,
                    searchPlaceholderText: 'Search Test',
                    itemsShowLimit: 3,
                    idField: 'id',
                    textField: 'name',
                    allowSearchFilter: true,
                    closeDropDownOnSelection: false
                  }"
                  [data]="radiologyTests"
                >
                </ng-multiselect-dropdown>
                <div
                  *ngIf="
                    testAndLocationForm.controls.radiologyTestsDetails.controls.radiologyTests.dirty &&
                    testAndLocationForm.controls.radiologyTestsDetails.controls.radiologyTests.errors
                  "
                  class="input-errors"
                >
                  <p
                    *ngIf="
                      testAndLocationForm.controls.radiologyTestsDetails.controls.radiologyTests.errors.required
                    "
                  >
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTestTypeId == testTypes.Lab || selectedTestTypeId == testTypes.Default" formGroupName="medicalTestsDetails">
            <h2 class="form-section-title">Lab Test Location</h2>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="test-location">
                    Where does the patient wants to test?
                  </label>
                  <select
                    formControlName="testLocation"
                    class="form-control"
                    id="test-location"
                  >
                    <option [value]="testVisitTypes.Home">At Home</option>
                    <option [value]="testVisitTypes.Branch">At Lab</option>
                  </select>
                  <div
                    *ngIf="
                      testAndLocationForm.controls.medicalTestsDetails.controls.testLocation.dirty &&
                      testAndLocationForm.controls.medicalTestsDetails.controls.testLocation.errors
                    "
                    class="input-errors"
                  >
                    <p
                      *ngIf="
                        testAndLocationForm.controls.medicalTestsDetails.controls.testLocation.errors.required
                      "
                    >
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="city"> City </label>
                  <select
                    formControlName="city"
                    class="form-control"
                    id="city"
                    (change)="
                      handleCityChange($event.target.value, testTypes.Lab); handleMedicalTestsCityName()
                    "
                  >
                    <option *ngFor="let city of cities" [value]="city.id">
                      {{ city.enName }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      testAndLocationForm.controls.medicalTestsDetails.controls.city.dirty &&
                      testAndLocationForm.controls.medicalTestsDetails.controls.city.errors
                    "
                    class="input-errors"
                  >
                    <p *ngIf="testAndLocationForm.controls.medicalTestsDetails.controls.city.errors.required">
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="area"> Area </label>
                  <select
                    formControlName="area"
                    class="form-control"
                    id="area"
                    (change)="handleMedicalTestsAreaName()"
                  >
                    <option *ngFor="let area of medicalTestsAreas" [value]="area.id">
                      {{ area.enName }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      (isSubmitted || testAndLocationForm.controls.medicalTestsDetails.controls.area.dirty) &&
                      testAndLocationForm.controls.medicalTestsDetails.controls.area.errors
                    "
                    class="input-errors"
                  >
                    <p *ngIf="testAndLocationForm.controls.medicalTestsDetails.controls.area.errors.required">
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="
                testAndLocationForm.controls.medicalTestsDetails.controls.testLocation.value ==
                testVisitTypes.Home
              "
              class="saved-address"
            >
              <h2 class="form-section-title">Please choose address from below</h2>
              <div class="address-container">
                <ul class="addresses">
                  <li
                    class="address-card"
                    *ngFor="let address of patient?.addresses; let i = index"
                  >
                    <input
                      type="radio"
                      [value]="address.patientAddressId"
                      [id]="'address' + i"
                      [name]="'address'"
                      formControlName="address"
                      (change)="onAddressChange(address)"
                    />
                    <label [for]="'address' + i">
                      <h6>
                        <span class="checkbox-icon"></span>
                        <span>{{ address?.title }}</span>
                      </h6>
                      <div class="divider"></div>
                      <div class="row">
                        <div class="col-6">
                          <p class="prop-key">City</p>
                          <p class="prop-value">{{ address?.cityName }}</p>
                        </div>
                        <div class="col-6">
                          <p class="prop-key">Area</p>
                          <p class="prop-value">{{ address?.areaName }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <p class="prop-key">Address</p>
                          <p class="prop-value">{{ address?.details }}</p>
                        </div>
                      </div>
                    </label>
                  </li>
                  <li
                    class="add-address"
                    (click)="openNotificationModal(addAddressModal)"
                  >
                    <span class="icon">
                      <i class="icon-add-address"></i>
                    </span>
                    <h3>Add New Address</h3>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTestTypeId == testTypes.Scan || selectedTestTypeId == testTypes.Default" formGroupName="radiologyTestsDetails">
            <h2 class="form-section-title">Radiology Test Location</h2>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="test-location">
                    Where does the patient wants to test?
                  </label>
                  <select
                    formControlName="testLocation"
                    class="form-control"
                    id="test-location"
                  >
                    <option [value]="testVisitTypes.Branch" >At Lab</option>
                  </select>
                  <div
                    *ngIf="
                      testAndLocationForm.controls.radiologyTestsDetails.controls.testLocation.dirty &&
                      testAndLocationForm.controls.radiologyTestsDetails.controls.testLocation.errors
                    "
                    class="input-errors"
                  >
                    <p
                      *ngIf="
                        testAndLocationForm.controls.radiologyTestsDetails.controls.testLocation.errors.required
                      "
                    >
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="city"> City </label>
                  <select
                    formControlName="city"
                    class="form-control"
                    id="city"
                    (change)="
                      handleCityChange($event.target.value, testTypes.Scan); handleRadiologyTestsCityName()
                    "
                  >
                    <option *ngFor="let city of cities" [value]="city.id">
                      {{ city.enName }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      testAndLocationForm.controls.radiologyTestsDetails.controls.city.dirty &&
                      testAndLocationForm.controls.radiologyTestsDetails.controls.city.errors
                    "
                    class="input-errors"
                  >
                    <p *ngIf="testAndLocationForm.controls.radiologyTestsDetails.controls.city.errors.required">
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-control-label" for="area"> Area </label>
                  <select
                    formControlName="area"
                    class="form-control"
                    id="area"
                    (change)="handleRadiologyTestsAreaName()"
                  >
                    <option *ngFor="let area of radiologyTestsAreas" [value]="area.id">
                      {{ area.enName }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      (isSubmitted || testAndLocationForm.controls.radiologyTestsDetails.controls.area.dirty) &&
                      testAndLocationForm.controls.radiologyTestsDetails.controls.area.errors
                    "
                    class="input-errors"
                  >
                    <p *ngIf="testAndLocationForm.controls.radiologyTestsDetails.controls.area.errors.required">
                      This field is required!
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="form-actions">
            <button class="btn cancel-btn" (click)="handleCancelTest()">
              Cancel
            </button>
            <button
              class="btn next-btn"
              [disabled]="testAndLocationForm.invalid || (!selectedTestTypeId && selectedTestTypeId != 0)"
              (click)="handleNextStep()"
            >
              Next Step
            </button>
          </div>
        </form>

        <form *ngIf="step == 2" [formGroup]="labForm">
          <div *ngIf="selectedTestTypeId == testTypes.Lab || selectedTestTypeId == testTypes.Default">
            <h2 class="form-section-title">Please Choose A Lab From Below</h2>
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th></th>
                    <th>LAB NAME</th>
                    <th *ngIf="!isHomeTest()">BRANCH NAME</th>
                    <th>TEST(S) FEES</th>
                    <th *ngIf="isHomeTest()">HOME VISIT</th>
                    <th *ngIf="isHomeTest()">TOTAL AMOUNT</th>
                  </tr>
                </thead>
                <tbody *ngIf="testLabs.length != 0; else noTestCentersTemplate">
                  <tr
                    *ngFor="let lab of testLabs; let i = index"
                    for="lab{{ i }}"
                    (click)="handleTestLabSelect(lab)"
                  >
                    <td>
                      <input
                        type="radio"
                        name="testLab"
                        id="lab{{ i }}"
                        formControlName="testLab"
                        [value]="lab"
                      />
                    </td>
                    <td>
                      <span>{{ lab.name }}</span>
                    </td>
                    <td *ngIf="!isHomeTest()">
                      <span>{{ lab.branch.name }}</span>
                    </td>
                    <td>
                      <span>{{ lab.totalPrice }}</span>
                    </td>
                    <td *ngIf="isHomeTest()">
                      <span>{{ lab.homeVisitFees }}</span>
                    </td>
                    <td *ngIf="isHomeTest()">
                      <span>{{
                        isHomeTest()
                          ? lab.totalPrice + lab.homeVisitFees
                          : lab.totalPrice
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="testLabs.length == 0" class="input-info text-center m-3">
              <p>No test centers are available for selected lab tests!</p>
            </div>
          </div>

          <div *ngIf="selectedTestTypeId == testTypes.Scan || selectedTestTypeId == testTypes.Default" [ngClass]="{'margin-top': selectedTestTypeId == testTypes.Default}">
            <h2 class="form-section-title">Please Choose A Radiology Center From Below</h2>
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th></th>
                    <th>LAB NAME</th>
                    <th *ngIf="!isHomeTest()">BRANCH NAME</th>
                    <th>TEST(S) FEES</th>
                    <th *ngIf="isHomeTest()">HOME VISIT</th>
                    <th *ngIf="isHomeTest()">TOTAL AMOUNT</th>
                  </tr>
                </thead>
                <tbody *ngIf="radiologyLabs.length != 0; else noRadiologyCentersTemplate">
                  <tr
                    *ngFor="let lab of radiologyLabs; let i = index"
                    for="lab{{ i }}"
                    (click)="handleRadiologyLabSelect(lab)"
                  >
                    <td>
                      <input
                        type="radio"
                        name="radiologyLab"
                        id="lab{{ i }}"
                        formControlName="radiologyLab"
                        [value]="lab"
                      />
                    </td>
                    <td>
                      <span>{{ lab.name }}</span>
                    </td>
                    <td *ngIf="!isHomeTest()">
                      <span>{{ lab.branch.name }}</span>
                    </td>
                    <td>
                      <span>{{ lab.totalPrice }}</span>
                    </td>
                    <td *ngIf="isHomeTest()">
                      <span>{{ lab.homeVisitFees }}</span>
                    </td>
                    <td *ngIf="isHomeTest()">
                      <span>{{
                        isHomeTest()
                          ? lab.totalPrice + lab.homeVisitFees
                          : lab.totalPrice
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="radiologyLabs.length == 0" class="input-info text-center m-3">
              <p>No radiology centers are available for selected radiology tests!</p>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn back-btn" (click)="handlePrevStep()">
              Back
            </button>
            <button
              class="btn next-btn"
              [disabled]="labForm.invalid"
              (click)="handleNextStep()"
            >
              Next Step
            </button>
          </div>
        </form>

        <form *ngIf="step == 3" [formGroup]="paymentForm">
          <h2 class="form-section-title">Payment Information</h2>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-control-label" for="payment-method">
                  Payment Method
                </label>
                <select
                  formControlName="paymentMethod"
                  class="form-control"
                  id="payment-method"
                  (change)="handlePaymentMethodChange()"
                >
                  <option
                    *ngFor="let paymentMethod of paymentMethods"
                    [value]="paymentMethod.id"
                  >
                    {{ paymentMethod.name }}
                  </option>
                </select>

                <div
                  *ngIf="
                    (isSubmitted || paymentForm.controls.paymentMethod.dirty) &&
                    paymentForm.controls.paymentMethod.errors
                  "
                  class="input-errors"
                >
                  <p *ngIf="paymentForm.controls.paymentMethod.errors.required">
                    This field is required!
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn back-btn" (click)="handlePrevStep()">
              Back
            </button>
            <button
              class="btn next-btn"
              (click)="handlePromecodeNextStep()"
            >
              Next Step
            </button>
          </div>
        </form>

        <div *ngIf="step == 4" class="test-request-info">
          <div class="title">
            <h4>Request Information</h4>
            <p>Please confirm the below information to create the request.</p>
          </div>
          <div class="request-info-container">
            <section class="info-section patient-details">
              <h5>Patient Details</h5>
              <div class="section-data">
                <div class="row">
                  <div class="col-6">
                    <p class="prop-key">Name</p>
                    <p class="prop-value">
                      {{ patient?.personalInfo?.fullName || "--" }}
                    </p>
                  </div>
                  <div class="col-6">
                    <p class="prop-key">National ID</p>
                    <p class="prop-value">
                      {{ patient?.personalInfo?.nationalId || "--" }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="prop-key">Mobile Number</p>
                    <p class="prop-value">
                      {{ patient?.personalInfo?.phone || "--" }}
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <div *ngIf="selectedTestTypeId == testTypes.Lab || selectedTestTypeId == testTypes.Default">
              <section class="info-section medical-tests">
                <h5>Medical Tests</h5>
                <div class="section-data">
                  <div class="row">
                    <div class="col-6">
                      <p class="prop-key">No. Of Tests</p>
                      <p class="prop-value">
                        {{ testAndLocationForm?.value?.medicalTestsDetails?.medicalTests?.length }}
                      </p>
                    </div>
                    <div class="col-6">
                      <p class="prop-key">Test Names</p>
                      <p class="prop-value tests-names">{{ getLabTestsNames() }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="prop-key">Test Place</p>
                      <p class="prop-value">{{ getLabTestLocation() }}</p>
                    </div>
                  </div>
                </div>
              </section>

              <section class="info-section lab-info">
                <h5>Medical Tests Lab Information</h5>
                <div class="section-data">
                  <h6 *ngIf="isHomeTest()">{{ labForm.value.testLab.name }}</h6>
                  <h6 *ngIf="!isHomeTest()">
                    {{ labForm.value.testLab.name }} -
                    {{ labForm.value.testLab.branch.name }}
                  </h6>
                  <div class="divider"></div>
                  <div class="row">
                    <div class="col-6">
                      <p class="prop-key">City</p>
                      <p class="prop-value">
                        {{
                          isHomeTest()
                            ? selectedAddress.cityName
                            : selectedCity.enName
                        }}
                      </p>
                    </div>
                    <div class="col-6">
                      <p class="prop-key">Area</p>
                      <p class="prop-value">
                        {{
                          isHomeTest()
                            ? selectedAddress.areaName
                            : selectedArea.enName
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="prop-key">Address</p>
                      <p *ngIf="isHomeTest()" class="prop-value">
                        {{ generateAddressDetails() || "--" }}
                      </p>
                      <p *ngIf="!isHomeTest()" class="prop-value">
                        {{ selectedCity.enName + ', ' + selectedArea.enName }}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div *ngIf="selectedTestTypeId == testTypes.Scan || selectedTestTypeId == testTypes.Default">
              <section class="info-section medical-tests">
                <h5>Radiology Tests</h5>
                <div class="section-data">
                  <div class="row">
                    <div class="col-6">
                      <p class="prop-key">No. Of Tests</p>
                      <p class="prop-value">
                        {{ testAndLocationForm?.value?.radiologyTestsDetails?.radiologyTests?.length }}
                      </p>
                    </div>
                    <div class="col-6">
                      <p class="prop-key">Test Names</p>
                      <p class="prop-value tests-names">{{ getRadiologyTestsNames() }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="prop-key">Test Place</p>
                      <p class="prop-value">{{ getRadiologyTestLocation() }}</p>
                    </div>
                  </div>
                </div>
              </section>

              <section class="info-section lab-info">
                <h5>Radiology Tests Lab Information</h5>
                <div class="section-data">
                  <h6>
                    {{ labForm.value.radiologyLab.name }} -
                    {{ labForm.value.radiologyLab.branch.name }}
                  </h6>
                  <div class="divider"></div>
                  <div class="row">
                    <div class="col-6">
                      <p class="prop-key">City</p>
                      <p class="prop-value">{{ selectedCity.enName }}</p>
                    </div>
                    <div class="col-6">
                      <p class="prop-key">Area</p>
                      <p class="prop-value">{{ selectedArea.enName }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p class="prop-key">Address</p>
                      <p class="prop-value">
                        {{ selectedCity.enName + ', ' + selectedArea.enName }}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <section class="info-section payment-info">
              <h5>Payment Information</h5>
              <div class="section-data">
                <div class="row">
                  <div class="col-6">
                    <p class="prop-key">Payment Method</p>
                    <p class="prop-value">{{ selectedPaymentMethod }}</p>
                  </div>
                  <div class="col-6">
                    <p class="prop-key">Test Fees</p>
                    <p class="prop-value">
                      {{ (labForm?.value?.testLab?.totalPrice + labForm?.value?.radiologyLab?.totalPrice)
                         || "--" }}
                    </p>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-6">
                    <p class="prop-key">Discount</p>
                    <p class="prop-value">
                      {{ discount > 0 ? discount : "--" }}
                    </p>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-6">
                    <p class="prop-key">Home Visit</p>
                    <p class="prop-value">
                      {{
                        isHomeTest() ? labForm.value.testLab.homeVisitFees : "--"
                      }}
                    </p>
                  </div>
                  <div class="col-6">
                    <p class="prop-key">Total Amount</p>
                    <p *ngIf="isHomeTest()" class="prop-value">
                      {{
                        (labForm?.value?.testLab?.totalPrice +
                        labForm?.value?.testLab?.homeVisitFees +
                        labForm?.value?.radiologyLab?.totalPrice -
                        discount) || "--"
                      }}
                    </p>
                    <p *ngIf="!isHomeTest()" class="prop-value">
                      {{ (labForm?.value?.testLab?.totalPrice
                        + labForm?.value?.radiologyLab?.totalPrice - discount) || "--" }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="form-actions">
            <button class="btn back-btn" (click)="handlePrevStep()">
              Back
            </button>
            <button
              class="btn next-btn confirm-btn"
              (click)="handleConfirmRequest()"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAddressModal>
  <div class="modal-header align-items-center lookup-header">
    <h6 class="pointer" *ngIf="returnToSub" (click)="modalRef.hide()">
      Back To Saved Addresses
    </h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="modalRef.hide()"
    >
      <span class="" aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body add-address-modal">
    <div class="lookup-card d-flex align-items-center flex-column bg-white">
      <h1>
        {{
          editMode && !readOnly
            ? "Edit Address"
            : readOnly
            ? "Address Details"
            : "Add New Address"
        }}
      </h1>
      <p>
        {{
          editMode && !readOnly
            ? "Updating below data is on your responsibility and you can’t undo this action once it’s saved."
            : readOnly
            ? ""
            : "Please add customers address details below"
        }}
      </p>
      <form #addressForm="ngForm">
        <div class="row">
          <div class="col-md-6">
            <label for="title">Address Title (ex: Home, Work ..etc)</label>
            <input
              type="text"
              name="title"
              id="title"
              [(ngModel)]="newAddress && newAddress.title"
              required
              class="w-100"
              #title="ngModel"
              appCheckValidity
              [appCheckValidity]="title"
              [readonly]="readOnly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="title">City</label>
            <select
              name="city"
              id="city"
              (change)="onCityChange($event.target.value)"
              [disabled]="readOnly"
            >
              <option disabled selected>Select City</option>

              <option
                *ngFor="let city of cityList"
                [selected]="newAddress.cityId == city.id"
                [value]="city.id"
              >
                {{ city.enName }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="title">Area</label>
            <select
              name="areaId"
              id="area"
              (change)="onAreaChange($event.target.value)"
              [disabled]="readOnly"
              [ngModel]="newAddress?.areaId"
            >
              <option disabled [selected]="!newAddress.areaId">
                Select Area
              </option>
              <option
                *ngFor="let area of areaList"
                [value]="area.id"
                [selected]="newAddress.areaId == area.areaId"
              >
                {{ area.enName }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="address">Address</label>
            <textarea
              name="address"
              id="address"
              cols="30"
              rows="2"
              [(ngModel)]="newAddress && newAddress.details"
              required
              #address="ngModel"
              appCheckValidity
              [appCheckValidity]="address"
              [readonly]="readOnly"
            ></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="bNum">Building Number</label>
            <input
              required
              type="text"
              name="bNum"
              id="bNum"
              class="w-100"
              [(ngModel)]="newAddress && newAddress.buildingNumber"
              #bNum="ngModel"
              appCheckValidity
              [appCheckValidity]="bNum"
              [readonly]="readOnly"
            />
          </div>

          <div class="col-md-6">
            <label for="floorNum">Floor Number</label>
            <input
              required
              type="number"
              name="floorNum"
              id="floorNum"
              class="w-100"
              [(ngModel)]="newAddress && newAddress.floorNumber"
              #floorNum="ngModel"
              appCheckValidity
              [appCheckValidity]="floorNum"
              [readonly]="readOnly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="apNum">Apartment Number</label>
            <input
              type="number"
              name="apNum"
              id="apNum"
              class="w-100"
              [(ngModel)]="newAddress && newAddress.apartmentNumber"
              #apNum="ngModel"
              appCheckValidity
              [appCheckValidity]="apNum"
              [readonly]="readOnly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="additionalDetails">Additional Details</label>
            <textarea
              name="additionalDetails"
              id="additionalDetails"
              cols="30"
              rows="2"
              [(ngModel)]="newAddress && newAddress.additionalDetails"
              [readonly]="readOnly"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center flex-column">
    <button
      [ngClass]="{ loading: loading }"
      type="submit"
      class="btn btn-psp-primary btn-round"
      [disabled]="!addressForm.valid"
      (click)="onSubmit(addressForm)"
      *ngIf="!readOnly"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>

    <button
      type="submit"
      class="btn btn-psp-primary btn-round"
      (click)="modalRef.hide()"
      *ngIf="readOnly"
    >
      Close
    </button>
  </div>
</ng-template>
